import { createDataStore } from "../utils/data_score";

const LANGUAGE_KEY = "marjo90rie-language";

export const SUPPORTED_LANGUAGES = ["french", "english"] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const languageStore = createDataStore<SupportedLanguage>(
  getLanguageFromLocalStorage()
);

export const useLanguage = languageStore.useData;

export function addLanguageToGlobalStore(language: SupportedLanguage) {
  languageStore.setData(language);
  localStorage.setItem(LANGUAGE_KEY, JSON.stringify(language));
}

function getLanguageFromLocalStorage(): SupportedLanguage {
  try {
    return JSON.parse(
      localStorage.getItem(LANGUAGE_KEY) ?? SUPPORTED_LANGUAGES[0]
    );
  } catch {
    return SUPPORTED_LANGUAGES[0];
  }
}
